import { Box, Flex, Grid, Text, Image } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import { NewTabIcon } from "@root/assets/icons/NewTabIcon";
import { useMainChatContext } from "@root/context/kps-chat-context";
import LinkIcon from "@root/assets/icons/linkicon";
import { ChevronRightIcon } from "@chakra-ui/icons";
import ktLogo from "@root/assets/icons/kt.svg";
import koreanLawLogo from "@root/assets/icons/korean-law-logo-small.png";

export const sources = [
  {
    url: "https://example.com/resource1",
    title: "Introduction to Chemical Safety",
    content: "An overview of safety protocols in chemistry labs.",
    metadata: {
      favicon: "",
    },
  },
  {
    url: "https://example.com/resource2",
    title: "Fire Hazard Procedures",
    content: "How to handle fire-related emergencies in laboratories.",
    metadata: {
      favicon: "",
    },
  },
  {
    url: "https://example.com/resource3",
    title: "Personal Protective Equipment",
    content: "Types and proper use of lab safety gear.",
    metadata: {
      favicon: "",
    },
  },
  {
    url: "https://example.com/resource4",
    title: "Emergency Exit Maps",
    content: "Evacuation plans and safety signage explained.",
    metadata: {
      favicon: "",
    },
  },
  {
    url: "https://example.com/resource5",
    title: "Spill Response Guidelines",
    content: "Steps to take when hazardous substances spill.",
    metadata: {
      favicon: "",
    },
  },
  {
    url: "https://example.com/resource6",
    title: "Lab Equipment Handling",
    content: "Safe use and maintenance of common lab tools.",
    metadata: {
      favicon: "",
    },
  },
  {
    url: "https://example.com/resource7",
    title: "Incident Reporting",
    content: "How to report lab accidents and near misses.",
    metadata: {
      favicon: "",
    },
  },
];

const ChatSourceData = ({
  onClose,
  sources,
}: {
  onClose?: () => void;
  sources: any;
}) => {
  const { setSourcesData } = useMainChatContext();
  const { t } = useTranslation("common");

  function handlePreviewClick(source: any) {
    if (typeof source === "object") {
      window.open(source?.signedUrl, "_blank");
    } else {
      window.open(source, "_blank");
    }
  }

  function renderSourcesBoxes() {
    return (
      <Grid templateColumns="repeat(4, minmax(0, 1fr))" gap="20px">
        {sources?.slice(0, 3)?.map((source: any, index: any) => (
          <Flex
            key={index}
            border="1px solid"
            borderColor="#F2F2F2"
            borderRadius="16px"
            p="10px 16px"
            flexDir="column"
            gap="10px"
            cursor={"pointer"}
            onClick={() => handlePreviewClick(source)}
            height="100%"
          >
            <Flex gap="5px" flexDirection={"column"}>
              <Flex flexDirection={"row"} justifyContent={"space-between"}>
                <LinkIcon />
                <Flex gap="8px" alignItems="center" cursor="pointer">
                  <NewTabIcon />
                </Flex>
              </Flex>
              <Flex w="100%">
                <Text
                  color="#111827"
                  fontWeight={600}
                  fontSize="16px"
                  marginBottom="5px"
                  marginTop="2px"
                  isTruncated
                  w="100%"
                >
                  {typeof source === "object"
                    ? source?.filename?.split("/").pop() || source?.filename
                    : source}
                </Text>
              </Flex>
            </Flex>
          </Flex>
        ))}
        <Flex
          border="1px solid"
          fontSize={"15px"}
          borderColor="#F2F2F2"
          borderRadius="16px"
          p="16px"
          justifyContent={"center"}
          alignItems={"center"}
          cursor={"pointer"}
          height="100%"
          onClick={() => setSourcesData(sources)}
          gap={"4px"}
        >
          <Text fontWeight={500} color={"#40599B"}>
            {`${t("translate.viewSource")}`}
          </Text>
          <ChevronRightIcon color={"#40599B"} fontSize={20} />
        </Flex>
      </Grid>
    );
  }

  function renderSourcesLogo(_source: any, index: number) {
    const sourceUrl =
      typeof _source === "object"
        ? _source?.signedUrl || _source?.url || ""
        : _source || "";
    const isKteUrl = sourceUrl.toLowerCase().includes("kte");
    const isKoreanLawUrl = sourceUrl.toLowerCase().includes("law.go.kr");
    if (isKteUrl || isKoreanLawUrl) {
      return (
        <Box
          width="20px"
          height="20px"
          borderRadius="full"
          border="2px solid #f3f6f9"
          marginLeft={index === 0 ? "0" : "-6px"}
          overflow="hidden"
          display="flex"
          alignItems="center"
          justifyContent="center"
          bg="#f3f6f9"
          boxShadow="0 1px 3px rgba(0, 0, 0, 0.12), 0 0 0 1px rgba(255, 255, 255, 0.8) inset"
          position="relative"
        >
          <Image
            src={isKteUrl ? ktLogo : koreanLawLogo}
            alt="Source Logo"
            width="88%"
            height="88%"
            objectFit="contain"
          />
        </Box>
      );
    }
    return (
      <Box
        key={index}
        width="20px"
        height="20px"
        borderRadius="full"
        bg="#E5E7EB"
        border="1px solid #FFFFFF"
        marginLeft={index === 0 ? "0" : "-6px"}
      />
    );
  }

  function renderSourcesCompact() {
    if (!sources?.length) {
      return null;
    }

    return (
      <Flex
        alignItems="center"
        gap="8px"
        p={"8px 16px"}
        borderRadius={"full"}
        background={"white"}
        cursor={"pointer"}
        onClick={() => setSourcesData(sources)}
      >
        <Flex alignItems="center">
          {sources?.map((_source: any, index: number) => {
            return renderSourcesLogo(_source, index);
          })}
        </Flex>
        <Text fontSize="14px" color="#404040" fontWeight={500}>
          {t("translate.sourcesCount", { count: sources?.length })}
        </Text>
      </Flex>
    );
  }

  return (
    <Box>
      {/* <Flex justifyContent={"space-between"}>
        <Text fontWeight={"600"} fontSize={"16px"}>
          {t("translate.sources")}
        </Text>
      </Flex> */}

      <Flex mt={"12px"} flexDirection={"column"} gap={"15px"}>
        {renderSourcesCompact()}
      </Flex>
    </Box>
  );
};

export default ChatSourceData;
